// Variant picker fix - hide fallback dropdown
document.addEventListener('DOMContentLoaded', function() {
    // Force hide the fallback select and any Choices.js wrappers
    const fallbackSelect = document.querySelector('select[data-product-select]');
    if (fallbackSelect) {
        fallbackSelect.style.display = 'none';
        
        // Also hide parent if it's a Choices wrapper
        const choicesWrapper = fallbackSelect.closest('.choices');
        if (choicesWrapper) {
            choicesWrapper.style.display = 'none';
        }
    }
});
